<template>
  <div>
    <el-form
      @submit.native.prevent
      class="cml-search-form"
      ref="listForm"
      :model="listForm"
      :inline="true"
      label-width="100px"
      size="mini"
    >
      <el-row>
        <el-form-item label="供应商" prop="supplierCodeList">
          <SupplierSelect
            multiple
            :value="listForm.supplierCodeList"
            @change-emit="val => (listForm.supplierCodeList = val)"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button type="primary" @click="onReset">清空</el-button>
        </el-form-item>
      </el-row>
    </el-form>

    <div v-show="selectTab === 'Tab1'">
      <CommonTable
        ref="CommonTableRefTab1"
        :loading="tableLoading"
        :tableHead="tableHeadTab1"
        :tableData="tableDataTab1"
        :tableParam="tableParamTab1"
        @page-size-change="pageSizeChange"
        @select-change="selectChange"
        @sort-change="sortChange"
      >
        <template #idSlot="{ row }">
          <div class="cml-sample-info">
            <el-image
              v-if="row.type !== 'RAW_MATERIAL'"
              style="width: 50px; height: 50px; margin-right: 5px;"
              :src="row.sampleVO.mainImage + $ImgQuality30"
              :preview-src-list="[row.sampleVO.mainImage + $ImgPreviewQuality]"
              :fit="fit"
            >
              <div slot="placeholder" class="sample-image-slot">
                加载中
              </div>
            </el-image>
            <div>
              <p>产品ID：{{ row.productId }} </p>
              <span @click="toDetail(row)">{{ row.productName }}</span>
            </div>
          </div>
        </template>
        <template #checkStatusNameSlot="{ row }">
          <p>{{ row.sampleCheckVO.checkStatusName }}</p>
        </template>
      </CommonTable>
    </div>
  </div>
</template>
<script>
import SupplierSelect from '@/components/SupplierSelect';
import CommonTable from '@/components/CommonTable';
import sampleMixin from '@/mixins/sampleMixin';

export default {
  components: {
    SupplierSelect,
    CommonTable,
  },
  mixins: [sampleMixin],
  props: {},
  data() {
    return {
      listForm: {
        supplierCodeList: [],
      },
      selectTab: 'Tab1',
      tableLoading: false,
      tableParamTab1: {
        pageNo: 1,
        pageSize: 20,
        orderBy: '',
      },
      tableHeadTab1: [
        { label: '产品信息', prop: 'id', slotColumn: true, slotName: 'idSlot' },
        { label: '供应商', prop: 'supplierName' },
        { label: '提交时间', prop: 'sumbitDate', width: 150, sortable: true },
        { label: '审核人', prop: 'checkUserName', width: 150 },
        {
          label: '审核结果',
          prop: 'checkStatusName',
          slotColumn: true,
          slotName: 'checkStatusNameSlot',
          width: 150,
        },
      ],
      tableDataTab1: {},
      selectionTab1: [],
      fit: 'contain'
    };
  },
  mounted() {
    this.getList();
    this.$refs.CommonTableRefTab1.changeHeight();
  },
  methods: {
    onSearch() {
      this[`tableParam${this.selectTab}`].pageNo = 1;
      this.getList();
    },
    getList() {
      const params = {
        ...this[`tableParam${this.selectTab}`],
        data: this.listForm,
      };
      if (!params.orderBy) {
        params.orderBy = 'sumbit_date desc';
      }
      params.data.statusList = ['PUT_ON', 'TAKE_OFF', 'REJECT'];
      this.tableLoading = true;
      this.$http.sampleManage
        .getSampleList(params)
        .then(result => {
          this[`tableData${this.selectTab}`] = {
            list: result.data.list.map(item => {
              item.sampleVO =
                item[this.filterParam(item.type).listDataParam] || [];
              item.sampleCheckVO = item.sampleCheckVO || '';
              item.checkUserName = item.sampleCheckVO.createByName || '';
              return item;
            }),
            total: result.data.total,
          };
          this[`selection${this.selectTab}`] = [];
          this.$refs[`CommonTableRef${this.selectTab}`].clearCheckboxRow();
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
</style>
